import React from 'react'
import Box from '@material-ui/core/Box'
import EmptyStudents from 'components/empty-page-state'
import PermContactCalendarOutlinedIcon from '@material-ui/icons/PermContactCalendarOutlined'
import EnhancedTable from 'components/tables/enhanced-table'
import { LeadTableItem } from './lead-table-item'
import { useIsTablet } from 'lib/hooks'

const ContactedLeads = ({
  contactedLeads,
  setUnviewedLeadCount,
  refetch,
  sortByFullName,
  sortByCreatedOn,
}) => {
  const isTablet = useIsTablet()

  return (
    <Box mt={4}>
      {contactedLeads.length === 0 ? (
        <EmptyStudents
          title="Leads"
          caption="No contacted leads."
          IconComp={() => <PermContactCalendarOutlinedIcon fontSize="large" />}
          removeButton
        />
      ) : (
        <EnhancedTable
          rows={contactedLeads.map(lead => (
            <LeadTableItem
              lead={lead}
              key={lead.id}
              setUnviewedLeadCount={setUnviewedLeadCount}
              refetch={refetch}
              showRelativeTime
            />
          ))}
          columns={[
            {
              id: 'name',
              label: 'Name',
              align: 'left',
              width: isTablet ? '80%' : '30%',
              mobile: true,
              sortable: true,
              sortComparator: sortByFullName,
            },
            {
              id: 'interest',
              label: 'Interest',
              align: 'left',
              width: '30%',
              mobile: false,
              sortable: false,
            },
            {
              id: 'submitted',
              label: 'Submitted',
              align: 'left',
              width: '20%',
              mobile: false,
              sortable: true,
              sortComparator: sortByCreatedOn,
            },
            {
              id: 'actions',
              label: '',
              align: 'right',
              width: '20%',
              mobile: true,
              sortable: false,
            },
          ]}
          label="Contacted Leads"
          numberOfRows={25}
          emptyState={() => null}
        />
      )}
    </Box>
  )
}

export default ContactedLeads
